import { render, staticRenderFns } from "./NotificationCardTitle.vue?vue&type=template&id=22a81816&scoped=true"
import script from "./NotificationCardTitle.vue?vue&type=script&lang=js"
export * from "./NotificationCardTitle.vue?vue&type=script&lang=js"
import style0 from "./NotificationCardTitle.vue?vue&type=style&index=0&id=22a81816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a81816",
  null
  
)

export default component.exports